import React from "react";
import { Button } from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";

function AnalyticsTabs() {
    const navigate = useNavigate();
    function onClickHandle(value: string) {
        if (value === "activity_log") {
            navigate("/analytics/activity-log");
        } else if (value === "like_dislike") {
            navigate("like-dislike");
        } else if (value === "unable_to_answer") {
            navigate("unable-to-answer");
        } else if (value === "podcasts_activity_log") {
            navigate("podcasts-activity-log");
        }else if (value === "all-interactions") {
            navigate("all-interactions");
        }
    }
    return (
        <div className=" grid grid-cols-1 sm:grid-cols-4 pt-4  gap-4">
            <Button className="font-medium bg-white text-black min-lg:w-72 h-40 p-2 shadow-lg" onClick={() => onClickHandle("activity_log")}>
                <strong className="text-green-800 text-xl">PROMPT LOG</strong>
                {/* <div className="font-sans text-green-800">(List of all the interactions with user id anonymized for a period)</div> */}
            </Button>

            <Button className="font-medium  bg-white text-black  min-lg:w-72 h-40 p-2" onClick={() => onClickHandle("like_dislike")}>
                <strong className=" text-green-800 text-xl">Useful / Not useful / All</strong>
            </Button>

            <Button className="font-medium bg-white text-black  min-lg:w-72 h-40 p-2" onClick={() => onClickHandle("unable_to_answer")}>
                <strong className=" text-green-800 text-xl">Unable to answer</strong>
            </Button>

            {/* <Button className="font-medium bg-white text-black  min-lg:w-72 h-40 p-2" onClick={() => onClickHandle("all-interactions")}>
                <strong className=" text-green-800 text-xl">All Interactions</strong>
            </Button> */}
        </div>
    );
}

export default AnalyticsTabs;
